/**
 * API and Cognito configuration.
 *
 * Reads runtime config from /config.json (same file used by the member portal,
 * deployed to the member portal S3 bucket and served via CloudFront).
 * Contains the API base URL and API key.
 */

/** Cognito configuration — same user pool as the member portal. */
export const COGNITO_REGION = 'us-east-1';
export const COGNITO_CLIENT_ID = 'ii6jv5p16q0lsvf974t6muhnq';
export const COGNITO_ENDPOINT = `https://cognito-idp.${COGNITO_REGION}.amazonaws.com/`;

/** Runtime config loaded from /config.json */
interface AppConfig {
  apiBaseUrl: string;
  apiKey: string;
}

let cachedConfig: AppConfig | null = null;

/**
 * Load runtime config from /config.json.
 * This is the same config file the member portal uses — served from CloudFront root.
 */
export async function loadAppConfig(): Promise<AppConfig> {
  if (cachedConfig) return cachedConfig;

  try {
    const response = await fetch('/config.json');
    if (response.ok) {
      const data = await response.json();
      cachedConfig = {
        apiBaseUrl: data.apiBaseUrl || '/api/v1',
        apiKey: data.apiKey || '',
      };
      return cachedConfig;
    }
  } catch {
    // Fall through to defaults
  }

  cachedConfig = {
    apiBaseUrl: import.meta.env.VITE_API_URL || '/api/v1',
    apiKey: '',
  };
  return cachedConfig;
}

/** Get cached config (must call loadAppConfig first). */
export function getAppConfig(): AppConfig {
  return cachedConfig || { apiBaseUrl: '/api/v1', apiKey: '' };
}
